// Copyright (c) 2016 Deere & Company

import KeyValuePair, {getDefaultState as getDefaultKeyValueState} from './key-value-pair';
import t from 'tcomb';

const ClaimUseAmount = t.struct({
    amount: t.String,
    unit: KeyValuePair
}, {
    name: 'ClaimUseAmount',
    strict: true
});

export const getDefaultState = () => new ClaimUseAmount({
    amount: '',
    unit: getDefaultKeyValueState()
});

export default ClaimUseAmount;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-use-amount.js